export const RESET_SIGNUP_ERRORS = 'signup/RESET_SIGNUP_ERRORS'

export interface ResetSignupErrorsAction {
  type: typeof RESET_SIGNUP_ERRORS
}

export const resetSignupErrors = (): ResetSignupErrorsAction => ({
  type: RESET_SIGNUP_ERRORS,
})
